module.exports = __webpack_public_path__ + "app/assets/images/woman13-46cb106576e85b47fa8a824d102e0e8c.jpg";